// TODO: read the real plan from the backend once Will exposes it.
// Note: the plan is currently client-supplied, so quotas are advisory
// until it's derived server-side from the authenticated user.
export default function useUserPlan() {
  return "basic";
}